import React, { FC } from "react";
import MenuLink from "../NavQuickLinks/Components/MenuLink";

const PopoverVerticalMenu = ({ menu }): FC => {
  return (
    <div style={{ padding: 10 }}>
      {menu &&
        menu.map(({ key, title, external, absolute, relative, below }) => (
          <MenuLink
            key={key}
            title={title}
            fontWeight="bold"
            relative={relative}
            absolute={absolute}
            external={external}
          />
        ))}
    </div>
  );
};

export default PopoverVerticalMenu;
